export var getcustnum = async (data) => {
    const a = process.env.REACT_APP_CUST_NUM
    const response = await fetch(`${a}=${data}`)
    const custnum = await response.json()
    if (response.status == 500){
        return false
    }else if (response.status == 205) {
        return false
    }else{
        return custnum
    }
}

export var storeOrder = (id, ordervector, ) => {
    const str = process.env.REACT_APP_STR
    fetch(`${str}=${id}&vec=${ordervector}`)
}

export var checkInventory = async () => {
    const b = process.env.REACT_APP_B
    
    const response = await fetch(`${b}`)
    const inv = await response.json()

    return inv
}